import React, { useState } from "react";
import { useSidebar } from "../../components/ui/sidebar";
import "./Game-Page.css";
import { ChevronRight } from "lucide-react";
import { Button } from "../../components/ui/button.jsx";
import { Drawer, DrawerClose, DrawerContent, DrawerDescription, DrawerFooter, DrawerHeader, DrawerTitle, DrawerTrigger } from "../../components/ui/drawer.tsx";

function GamePage() {
  const { structuredPages } = useSidebar(); // Extract structuredPages from context
  const [open, setOpen] = useState(false); // State for drawer open/close
  const [currentPageKey, setCurrentPageKey] = useState(null); // Store the current game key

  // Toggle drawer open/close
  const handleToggleDrawer = (gameName) => {
    setCurrentPageKey(gameName); // Set the selected page
    setOpen(true); // Open the drawer
  };

  return (
    <div className="games-list">
      <div className="header">
        {/* Uncomment if you want to display the logo */}
        {/* <img className="denda-games" src={Denda} alt="Denda's games" /> */}
      </div>
      <div className="content">
        <div className="searchbar"></div>
        <ul className="game-name-container">
          {/* Map over structuredPages and render each game name */}
          {Object.keys(structuredPages).map((gameName) => {
            if (gameName.toLowerCase() === "administration") {
              return null; // Skip the 'administration' page
            }
            return (
              <li key={gameName} className="game-names" onClick={() => handleToggleDrawer(gameName)}>
                <h2>{gameName}</h2>
                <ChevronRight />
              </li>
            );
          })}
        </ul>
      </div>
      {/* Render the drawer */}
      <Drawer>
        <DrawerTrigger>Open</DrawerTrigger>
        <DrawerContent>
          <DrawerHeader>
            <DrawerTitle>Are you absolutely sure?</DrawerTitle>
            <DrawerDescription>This action cannot be undone.</DrawerDescription>
          </DrawerHeader>
          <DrawerFooter>
            <Button>Submit</Button>
            <DrawerClose>
              <Button variant="outline">Cancel</Button>
            </DrawerClose>
          </DrawerFooter>
        </DrawerContent>
      </Drawer>

      {/*<Drawer className="subpage-drawer" open={open} onClose={handleCloseDrawer} anchor={"bottom"}>*/}
      {/*    <div className="drawer-content">*/}
      {/*        <h2 className="drawer-heading">{currentPageKey}</h2>*/}
      {/*        <Divider className="drawer-divider"/>*/}
      {/*        <DrawerList className=" drawer-list"/>*/}
      {/*    </div>*/}
      {/*</Drawer>*/}
    </div>
  );
}

export default GamePage;
